import { EntityDetail } from '@user/store/map/typings'
import { useMemo } from 'react'
import { getSalesFunnelStage } from '@user/features/MapView/MultiTenantDrawer/MultiTenantDrawerContentSingle/hooks/useData'
import { LocationDTO } from '@sales-center/common'

type Props = {
  entityDetails: EntityDetail | null
  variant: string
  serviceLocation: LocationDTO
}

export function useStatusSectionData(props: Props) {
  const { entityDetails, variant, serviceLocation } = props

  const entityType = useMemo(() => {
    switch (variant.toLowerCase()) {
      case 'lead':
        return 'Lead'
      case 'opportunity':
        return 'Opportunity'
      case 'draftlead':
        return 'Pending Lead'
      default:
        return 'Unknown'
    }
  }, [variant])

  const knockStatus = useMemo(() => {
    console.log(serviceLocation)
    return {
      isDefault:
        serviceLocation?.knockStatusDetails?.knockStatusSettingsName ===
        'Do not knock'
          ? true
          : false,
      status:
        serviceLocation?.knockStatusDetails?.knockStatusSettingsName || 'None',
      note: serviceLocation?.knockStatusDetails?.mostRecentNote || null,
    }
  }, [serviceLocation])

  const status = useMemo(() => {
    return getSalesFunnelStage(entityType, entityDetails?.salesFunnelStage)
  }, [entityType, entityDetails])

  const entityTypeDisplay = useMemo(() => {
    switch (variant.toLowerCase()) {
      case 'lead':
        return 'Lead'
      case 'opportunity':
        return 'Opportunity'
      case 'draftlead':
      case 'pendinglead':
        return 'Pending Lead'
      default:
        return 'Unknown'
    }
  }, [variant])

  return {
    knockStatus,
    status,
    entityTypeDisplay,
    id: entityDetails?.id ?? 0,
    nextActionDate: entityDetails?.nextActionDate ?? null,
  }
}
